import { useAuth } from "../../../context/AuthContext";

// Per-client module switches (superadmin → CompanyModulePermission).
// Fetched and cached once in AuthContext (which also resolves clientName
// from /users/me when the login-time localStorage write hasn't landed yet);
// this keeps the old `{ modulePermissions, loadingPermissions }` shape for
// the shell. The argument is accepted for call-site compatibility.
const useModulePermissions = (/* BASE_URL */) => {
    const { clientModules, clientModulesLoading } = useAuth();
    return { modulePermissions: clientModules, loadingPermissions: clientModulesLoading };
};

export default useModulePermissions;
